import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-asp-network-issue',
  templateUrl: './asp-network-issue.component.html',
  styleUrls: ['./asp-network-issue.component.scss']
})
export class AspNetworkIssueComponent implements OnInit {
  isOnline = navigator.onLine;
constructor(
  private cdRef: ChangeDetectorRef,
  private aspLoadingService: AspLoadingService,
  private toastr: ToastrService,  
) {}

ngOnInit(): void {
  // setTimeout(() => {
  //   window.addEventListener('online', () => {
  //     console.log('ONLINE event fired');
  //     this.isOnline = true;
  //   });

  //   window.addEventListener('offline', () => {
  //     console.log('OFFLINE event fired');
  //     this.isOnline = false;
  //   });

  //   console.log('Initial isOnline:', this.isOnline);
  // });
}


tryAgain() {
  if (navigator.onLine) {
    this.isOnline = true;
    location.reload(); // reloads the whole page
  } else {
    this.aspLoadingService.hide();
    this.toastr.error('Please check your connection.');
  }
}

//   closePopup() {
//   this.isOnline = true;
// }

}
